import { cn } from "@/lib/utils";

export const inputCls = "w-full h-12 rounded-xl border border-[#D9CDBF] bg-white px-4 text-base text-[#241D17] placeholder:text-[#9A8B7E] focus:outline-none focus:ring-2 focus:ring-[#C59B27] focus:border-[#C59B27]";
export const textareaCls = "w-full min-h-[120px] rounded-xl border border-[#D9CDBF] bg-white px-4 py-3 text-base text-[#241D17] focus:outline-none focus:ring-2 focus:ring-[#C59B27]";

export const Field = ({ label, hint, children, required, htmlFor }) => (
  <div className="space-y-1.5">
    <label htmlFor={htmlFor} className="block text-[15px] font-bold text-[#241D17]">
      {label}{required && <span className="text-[#B85028]"> *</span>}
    </label>
    {children}
    {hint && <p className="text-sm text-[#605349]">{hint}</p>}
  </div>
);

export const CheckRow = ({ checked, onChange, label, sub, testid, tone }) => (
  <label data-testid={testid} className={cn(
    "flex items-start gap-3 rounded-xl border p-4 cursor-pointer transition-colors duration-150",
    checked ? "border-[#3D6346] bg-[#EBF2EC]" : "border-[#E7DFD5] bg-white hover:bg-[#FAF8F5]",
    tone === "warn" && checked && "border-[#B85028] bg-[#F6E3DC]")}>
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
      className="mt-1 w-5 h-5 accent-[#3D6346] shrink-0" />
    <span>
      <span className="block text-[15px] text-[#241D17] font-semibold leading-snug">{label}</span>
      {sub && <span className="block text-sm text-[#605349] mt-0.5">{sub}</span>}
    </span>
  </label>
);

export const BigButton = ({ className, variant = "primary", ...p }) => (
  <button {...p} className={cn(
    "h-14 px-7 rounded-full text-base font-bold inline-flex items-center justify-center gap-2 transition-colors duration-150 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-[#C59B27] focus:ring-offset-2",
    variant === "primary" && "bg-[#4A2E1A] text-[#FDFBF7] hover:bg-[#362112]",
    variant === "green" && "bg-[#3D6346] text-white hover:bg-[#2D4A34]",
    variant === "ghost" && "bg-transparent text-[#4A2E1A] border border-[#D9CDBF] hover:bg-[#F4EBE4]",
    className)} />
);

export const localToday = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const GkkOptions = ({ gkks }) => {
  const zones = [...new Set(gkks.map((g) => g.zone || "Other"))];
  return zones.map((z) => (
    <optgroup key={z} label={z}>
      {gkks.filter((g) => (g.zone || "Other") === z).map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
    </optgroup>
  ));
};

